import { render, staticRenderFns } from "./OtherCostList.vue?vue&type=template&id=1d32ec5a&scoped=true&"
import script from "./OtherCostList.vue?vue&type=script&lang=js&"
export * from "./OtherCostList.vue?vue&type=script&lang=js&"
import style0 from "./OtherCostList.vue?vue&type=style&index=0&id=1d32ec5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32ec5a",
  null
  
)

export default component.exports